export const tempUserInfo = state => state.authReducer.tempUserInfo

export const currentUserInfo = state => state.authReducer.currentUserInfo
